export default "__VITE_ASSET__D7YZ4oGR__"